import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'vant/lib/index.css'
import '@/utils/vant'
import { datePipe } from '@/utils/utils'
import dayjs from 'dayjs'
Vue.filter('date', datePipe)
Vue.prototype.$dayjs = dayjs
Vue.config.productionTip = false
// 设置浏览器标题
Vue.directive('title', {
  inserted: function (el, binding) {
    document.title = el.dataset.title
  }
})
new Vue({
  router,
  render: (h) => h(App)
}).$mount('#app')
